import Vue from 'vue'
import Vuex from 'vuex'
import oauth from './modules/oauth'
import loader from './modules/loader'
import today from './modules/today'
import form from './modules/form'
import confirmauthentification from './modules/confirmauthentification'
import modif from './modules/modif'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    oauth,
    loader,

    today,
    form,
    confirmauthentification,
    modif,
  },
})

export default store
